import {
	PolicyCost,
} from '@app/models/api';

export default class EndorsementResponseCostValues {

	public oldPolicyCosts: PolicyCost | null = null;
	public newPolicyCosts: PolicyCost | null = null;
	public endorsementCost: PolicyCost | null = null;

	public EndorsementResponseCostValues() {

	}
}